import Swiper from "swiper"
import { Autoplay, Pagination, Navigation } from "swiper/modules"

Swiper.use([Autoplay, Pagination, Navigation])

const defaultConfig = {
  slidesPerView: 1,
  loop: true,
  speed: 1000,
  pagination: {
    clickable: true,
    el: ".swiper-pagination",
    type: "bullets",
  },
  navigation: {
    addIcons: false,
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  observer: true,
  observeParents: true,
}

const collectionsConfig = {
  ...defaultConfig,
  loop: false,
  spaceBetween: 30,
  breakpoints: {
    0: {
      slidesPerView: 1.1,
      pagination: {
        enabled: true,
      },
      allowTouchMove: true,
    },
    800: {
      slidesPerView: 2.2,
      pagination: {
        enabled: true,
      },
      allowTouchMove: true,
    },
    1100: {
      slidesPerView: 3.2,
      pagination: {
        enabled: true,
      },
      allowTouchMove: true,
    },
    1366: {
      slidesPerView: 4,
      loopedSlides: 4,
      pagination: {
        enabled: false,
      },
      allowTouchMove: false,
    },
  },
}

function getConfig(type) {
  if (type === "collections") {
    return collectionsConfig
  }

  return defaultConfig
}

;(() => {
  function initSwiper() {
    const elements = document.querySelectorAll(".swiper-container")

    for (const element of elements) {
      new Swiper(element, getConfig(element.dataset.swiperConfig))
    }
  }

  window.addEventListener("load", () => {
    initSwiper()
  })
})()
